import {ReportListState} from "./ReportListState";
import {ReportSummary} from "../../model/report/ReportSummary";
import {PageMetadata} from "../../model/PageMetadata";

export class UserReportListState extends ReportListState {
    constructor(public userId: number | undefined = undefined,
                reportSummaries: ReportSummary[] = [],
                pageMetadata: PageMetadata = new PageMetadata(),
                pendingRequest: boolean = false,
                loaded: boolean = false) {
        super(reportSummaries, pageMetadata, pendingRequest, loaded);
    }
}